import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: null
    },
    mutations: {
        SET_USER_DATA(state, userData) {
            state.user = userData
            localStorage.setItem('user', JSON.stringify(userData))
            axios.defaults.headers.common[
                'Authorization'
            ] = `Bearer ${userData.token}`
        },
        LOGOUT() {
            localStorage.removeItem('user')
            location.reload()
        }
    },
    actions: {
        register({ commit }, credentials) {
            return axios
                .post(process.env.VUE_APP_API_DOMAIN + '/register', credentials)
                .then(({ data }) => {
                    commit('SET_USER_DATA', data)
                })
        },
        profileUpdate({ commit }, credentials) {
            return axios
                .post(
                    process.env.VUE_APP_API_DOMAIN + '/profile/update',
                    credentials
                )
                .then(({ data }) => {
                    commit('SET_USER_DATA', data)
                })
        },
        login({ commit }, credentials) {
            return axios
                .post(process.env.VUE_APP_API_DOMAIN + '/login', credentials)
                .then(({ data }) => {
                    commit('SET_USER_DATA', data)
                })
        },
        logout({ commit }) {
            commit('LOGOUT')
        },
        newPassword({ commit }, credentials) {
            return axios
                .post(
                    process.env.VUE_APP_API_DOMAIN + '/password/new',
                    credentials
                )
                .then(({ data }) => {
                    commit('SET_USER_DATA', data)
                })
        }
    },
    modules: {},
    getters: {
        loggedIn(state) {
            return !!state.user
        }
    }
})
